export default {
  startPage: 0,
  url: "vbm.pennsylvania-votes.org",
};
